import React from 'react'
import {db, auth, firebase} from '../firebase'

export const UserContext = React.createContext()

const UserProvider = (props) => {

    const dataUserInitial = {
        email: null,
        uid: null,
        active: null
    }

    const iniciarSesion = async () => {
        try {
            const provider = new firebase.auth.GoogleAuthProvider()
            const res = await auth.signInWithPopup(provider)
            const exist = db.collection('users').doc(res.email).get()
            
            if(!exist.exists) {
                await db.collection('users').doc(res.user.email).set({
                    uid: res.user.uid,
                    email: res.user.email,
                    rol: 'invitado'
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const cerrarSesion = () => {
        auth.signOut();
    }

    const [user] = React.useState(dataUserInitial);

    return (
        <UserContext.Provider value={user, iniciarSesion, cerrarSesion}>
            {props.children}
        </UserContext.Provider>
    )
}

export default UserProvider;
